import React from "react";
import "./BasicTag.scss";
class BasicTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: props.tag,
    };
  }
  render() {
    if (this.props.tag.length > 0) {
      return (
        <div className={this.props.tagClass ? this.props.tagClass : "basicTag"}>
          {this.props.tag}
        </div>
      );
    } else {
      return <div class="placeHolder"></div>;
    }
  }
}
export default BasicTag;
